var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tomo"},[_c('h2',[_vm._v("Yet another way to connect web3 & metaverse")])])}]

export { render, staticRenderFns }